"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const _ui_1 = require("@ui");
const util_1 = require("@app/util");
const Error = ({ type, children, message }) => (react_1.default.createElement(_ui_1.Text, { color: _ui_1.Text.COLORS.DANGER, type: _ui_1.Text.TYPES.BODY_MEDIUM },
    type ? (0, util_1.t)(util_1.errorUtil.getErrorMessage(type) ?? '') : null,
    type
        ? message
            ? ' (' + message + ')'
            : null
        : message,
    children));
exports.default = Error;
